<template>
    <main class="flex flex-col items-center justify-between overflow-y-auto px-4 py-8 md:px-12">
        <figure class="flex flex-col gap-10 lg:w-full lg:gap-11 pb-32">
            <form method="POST" :action="submitUrl" id="accept-form">
                <v-csrf-token></v-csrf-token>
                <figure class="mx-auto flex flex-col gap-8 lg:w-full">
                    <figure class="flex gap-3 mx-auto max-w-xl w-full">
                        <div><v-icon icon="check-circle" size="8"></v-icon></div>
                        <div class="flex flex-col gap-3">
                            <div class="text-heading-3-desktop">
                                Sprejmite pogoje
                            </div>
                            <div class="text-body-regular text-black-40">
                                S splošnimi pogoji poslovanja in varovanja osebnih podatkov podjetja n24 se morate strinjati. V kolikor se ne strinjate, ne morete uporabljati aplikacije N24.
                            </div>
                        </div>
                    </figure>
                    <figure class="flex flex-wrap justify-center gap-x-8 gap-y-6 mt-12 max-w-lg mx-auto w-full" id="plans">
                        <v-checkbox
                            class="flex-row-reverse justify-between text-body-medium"
                            name="newsletter"
                            label="Želim prejemati novice"
                        ></v-checkbox>
                        <v-checkbox
                            @checkchange="termsCheckedChanged"
                            class="flex-row-reverse justify-between text-body-medium"
                            name="terms_and_conditions"
                            label='Strinjam se s spošnimi pogoji poslovanja in <a class="text-green underline" href="/izjava-o-varstvu-osebnih-podatkov">varstva osebnih podatkov</a>'
                        ></v-checkbox>
                    </figure>
                </figure>
            </form>
        </figure>
    </main>
    <footer
        class="fixed bottom-0 z-10 flex max-h-[102px] min-h-[102px] w-full justify-between border-t bg-white px-4 lg:max-h-[90px] lg:min-h-[90px]">
        <div class="flex w-full justify-center items-center">
            <button class="button flex items-center gap-2" :class="{'button--gray cursor-not-allowed': terms != true}" :disabled="terms != true" @click="submit">
                <span>Nadaljujte</span>
                <v-icon icon="arrow-right" class="h-4 w-4"/>
            </button>
        </div>
    </footer>
</template>

<script>
export default {
    props: {
        submitUrl: {
            type: String,
            required: true,
        },
        defaultAcceptsTerms: {
            required: false,
            default: false,
        },
        defaultNewsletter: {
            required: false,
            default: false,
        }
    },
    data() {
        return {
            terms: false,
            newsletter: false,
        }
    },
    mounted() {
        this.terms = this.defaultAcceptsTerms ?? false;
        this.newsletter = this.defaultNewsletter ?? false;
    },
    computed: {
        validated() {
            if (!this.terms) {
                return false;
            }

            return true;
        }
    },
    methods: {
        submit() {
            if (!this.validated) {
                return;
            }

            document.getElementById('accept-form').submit();
        },
        termsCheckedChanged(newVal) {
            this.terms = newVal;
        }
    }
};
</script>
